import { render, staticRenderFns } from "./head-menu.vue?vue&type=template&id=5126e06d&scoped=true&"
import script from "./head-menu.vue?vue&type=script&lang=ts&"
export * from "./head-menu.vue?vue&type=script&lang=ts&"
import style0 from "./head-menu.vue?vue&type=style&index=0&id=5126e06d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5126e06d",
  null
  
)

export default component.exports